import React, { createContext, useState, useCallback, ReactNode } from 'react';
import { IDevice } from './DevicesManagementPage';
import { getDevices as fetchDevices } from './services';

// Define the context type
export interface DevicesContextType {
  devices: IDevice[];
  loading: boolean;
  refreshDevices: (includeInactive: boolean) => Promise<void>;
}

// Create context with default values
export const DevicesContext = createContext<DevicesContextType>({
  devices: [],
  loading: false,
  refreshDevices: async () => {},
});

// Props for the provider component
interface DevicesProviderProps {
  children: ReactNode;
}

// Create provider component
export const DevicesProvider: React.FC<DevicesProviderProps> = ({ children }) => {
  const [devices, setDevices] = useState<IDevice[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  // Function to fetch and refresh devices data
  const refreshDevices = useCallback(async (includeInactive = true) => {
    setLoading(true);
    try {
      const fetchedDevices = await fetchDevices(includeInactive);
      setDevices(fetchedDevices);
    } catch (error) {
      console.error('Error fetching devices:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  return <DevicesContext.Provider value={{ devices, loading, refreshDevices }}>{children}</DevicesContext.Provider>;
};
